import React, { useState, useContext, useRef } from "react";
import { UserDataContext } from "../../App";
import { Button, InputAdornment, Box, Grid, Divider } from "@mui/material";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { Message, Lock, VkBlue, Google, SocIconYandex, SocIconFB } from "../../assets/images/icons";
import REST from "../../libs/API";
import { getText } from "../../libs/utils";
import { styled } from "@mui/material/styles";
import { useNavigate } from 'react-router-dom';
import { openSocAuth } from "../../libs/utils";

const MyDivider = styled(Divider)(() => ({
  margin: "20px 0 17px",
}));

const Auth = ({ setActiveForm, setOpenDialog, socialLinks = {}, noRedirect = false }) => {
  const userData = useContext(UserDataContext);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ email: "", password: "" });
  const navigate = useNavigate();
  const fieldRefs = useRef({});

  const handlerSubmit = () => {
    const { email, password } = formData;
    setLoading(true);
    REST
      .auth(email, password)
      .then(data => {
        if (!data.success) {
          window.showMessage((data.data && data.data[0] && data.data[0].message) || getText('onError'), { variant: 'warning' })
        } else {
          window.showMessage('Вы авторизированы');
          userData.auth(data.data.token, email, true);
          setOpenDialog(false);
          getUserProfile(data.data.token);
          
        }
        setLoading(false);
      });
  }

  const getUserProfile = (token) => {
    REST.getProfileData(token).then(data => {
      if (data.success) {
        userData.setHasKyc(data.data.hasKyc);
        !noRedirect && navigate('/account');
      }
    });
  }

  return (
    <ValidatorForm
      onSubmit={handlerSubmit}
      instantValidate={false}
    >
      <TextValidator
        fullWidth
        placeholder="E-mail"
        variant="standard"
        name="email"
        ref={el => fieldRefs.current['email'] = el}
        onBlur={event => fieldRefs.current[event.target.name].validate(event.target.value)}
        onChange={(event) =>
          setFormData({
            ...formData,
            [event.target.name]: event.target.value,
          })
        }
        validators={["required", "isEmail"]}
        errorMessages={[
          getText('reqiuredField'),
          getText('loginIncorectMail'),
        ]}
        value={formData.email}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Message />
            </InputAdornment>
          ),
        }}
      />

      <TextValidator
        fullWidth
        placeholder={getText('loginFormPassLabel')}
        variant="standard"
        name="password"
        ref={el => fieldRefs.current['password'] = el}
        onBlur={event => fieldRefs.current[event.target.name].validate(event.target.value)}
        type="password"
        onChange={(event) =>
          setFormData({
            ...formData,
            [event.target.name]: event.target.value,
          })
        }
        validators={["required"]}
        errorMessages={[getText('reqiuredField')]}
        value={formData.password}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Lock />
            </InputAdornment>
          ),
        }}
      />

      <Button
        fullWidth
        variant="contained"
        disabled={loading}
        size="large"
        type="submit"
      >
        {getText('loginFormEnterBtn')}
      </Button>

      <Grid container sx={{ marginTop: '6px' }}>
        <Grid item xs={6}>
          <span className="link-secondary" onClick={() => setActiveForm('Register')}>
            {getText('registerButton')}
          </span>
        </Grid>
        <Grid item xs={6} style={{ textAlign: "right" }} onClick={() => setActiveForm('ForgotPass')}>
          <span className="link-secondary">{getText('loginFormForgotBtn')}</span>
        </Grid>
      </Grid>

      {Object.keys(socialLinks).length > 0 && <MyDivider />}

      <Box sx={{ justifyContent: "center", display: 'flex', flexWrap: 'nowrap', gap: '16px' }}>
        {false && socialLinks.vk && (
          <Box sx={{ cursor: 'pointer' }} onClick={() => openSocAuth(socialLinks, "vk")}>
            <VkBlue />
          </Box>
        )}
        {false && socialLinks.google && (
          <Box sx={{ cursor: 'pointer' }} onClick={() => openSocAuth(socialLinks, "google")}>
            <Google />
          </Box>
        )}
        {socialLinks.yandex && (
          <Box sx={{ cursor: 'pointer' }} onClick={() => openSocAuth(socialLinks, "yandex")}>
            <SocIconYandex />
          </Box>
        )}
        {socialLinks.facebook && (
          <Box sx={{ cursor: 'pointer' }} onClick={() => openSocAuth(socialLinks, "facebook")}>
            <SocIconFB />
          </Box>
        )}
      </Box>
    </ValidatorForm>
  );
};

export default Auth;
